import {select, fork, take, put} from 'redux-saga/effects';
import {fetchRequest} from '@computerrock/formation-core';
import * as dashboardActionTypes from '../dashboardActionTypes';
import * as applicationActionTypes from '../../application/applicationActionTypes';

const loadNews = function* loadTopics() {
    const {serviceManager, links} = yield select(state => state.application);

    const ftemStrapiService = serviceManager.loadService('ftemStrapiService');
    const filterParamsString = 'sort=publishedAt:asc';

    yield fork(
        fetchRequest,
        dashboardActionTypes.FETCH_NEWS_REQUEST,
        ftemStrapiService.getNews,
        {filterParamsString},
    );

    const responseAction = yield take([
        dashboardActionTypes.FETCH_NEWS_REQUEST_SUCCEEDED,
        dashboardActionTypes.FETCH_NEWS_REQUEST_FAILED,
    ]);

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {newsObj} = response;
        yield put({
            type: dashboardActionTypes.STORE_NEWS,
            payload: {
                newsObj,
            },
        });
        const linksNew = newsObj.map(element => element.links).flat().filter(link => link);
        yield put({
            type: applicationActionTypes.STORE_LINKS,
            payload: {links: linksNew, linksPrev: links},
        });
    } else {
        yield put({
            type: dashboardActionTypes.STORE_NEWS,
            payload: {
                newsObj: false,
            },
        });
    }
};

export default loadNews;
